import React from 'react';
import { CountryFlag } from 'project/country-flag';
import { livePlayer } from 'components/live-player';
import { sortAscAZ } from './sortingStrategies';

class LeaderboardAlphaList extends React.Component {
    renderRow(player) {
        return (
            <div className="leaderboard__row leaderboard__row--alpha" key={player.playerId}>
                <div className="leaderboard__cell leaderboard__cell--player leaderboard__cell--player-wide">
                    <div className="leaderboard__cell-content">
                        <div className="leaderboard__cell-player">
                            <button
                                className="leaderboard__cell-player-wrap"
                                type="button"
                                onClick={() => livePlayer.show(player.playerId)}
                            >
                                <CountryFlag
                                    childCss={'leaderboard__cell-player-flag country-flag country-flag--base has-image'}
                                    image={player.countryFlagSrc}
                                    title={player.country}
                                />
                                <div className="leaderboard__cell-player-fullname ">
                                    <div className="leaderboard__cell-player-lastname">{player.lastName}</div>
                                    <span className="leaderboard__cell-player-separator">,</span>
                                    <div className="leaderboard__cell-player-firstname">{player.firstName}</div>
                                    { player.isAmateur && <span className="leaderboard__cell-player-amateur">(a)</span> }

                                </div>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    render() {
        const { players } = this.props;

        if (!Array.isArray(players)) return null;

        const sortedPlayers = sortAscAZ(players, 'lastName');

        return (
            <div className="leaderboard">
                {sortedPlayers.map((player) => this.renderRow(player))}
            </div>
        );
    }
}

export default LeaderboardAlphaList;
